import truncate from "lodash/truncate";

function ellipsis() {
  return function (input, length) {
    return truncate(input, { length: length });
  };
}

export default ellipsis;
